import React from 'react'
import SEO from "../../common/SEO";
import HeaderOne from '../../common/header/HeaderOne';
import HeaderTopNews from '../../common/header/HeaderTopNews';
import FooterOne from '../../common/footer/FooterOne';
import Copyright from '../../common/footer/Copyright';
import { FiArrowRight } from 'react-icons/fi';
import SectionTitle from '../../elements/sectionTitle/SectionTitle';
import SpeakingCategories from '../../components/speaking/SpeakingCategories';
import SpeakingSpeaker from '../../components/speaking/SpeakingSpeaker';
import Separator from '../../elements/separator/Separator';
import SpeakingCallToAction from '../../components/speaking/SpeakingCallToAction';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import TrainingMenu from '../../components/training/TrainingMenu';
import TrainingAbout from '../../components/training/TrainingAbout';
import TrainingTopics from '../../components/training/TrainingTopics';
import TrainingCategories from '../../components/training/TrainingCategories';
import TrainingCallToAction from './../../components/training/TrainingCallToAction';
import TrainingTestimonial from '../../components/training/TrainingTestimonial';
import TrainingVideo from '../../components/training/TrainingVideo';
import SpeakingDetails from './SpeakingDetails';
import SpeakerAbout from './../../components/speaking/SpeakerAbout';
import MainTestimonial from '../../elements/testimonial/MainTestimonial';
import TrainingForm from '../../components/training/TrainingForm';
import TrainingTrainer from '../../components/training/TrainingTrainer';
const Training = () => {
    
    return (
        <>
            <SEO title="Book Trainer" />
            <main className="page-wrapper">
                {/* <HeaderTopNews /> */}
                <HeaderOne  btnStyle="btn-small round btn-icon" HeaderSTyle="header-transparent" />

                {/* Start Slider Area  */}
                <div className="slider-area slider-style-1 variation-default height-850 bg_image" data-black-overlay="7" style={{backgroundImage: `url(${process.env.PUBLIC_URL}/images/training/hero.jpg)`}}>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="inner text-center">
                                    {/* <h1 className="title display-one">Book keynote trainer<br></br> who <span style={{color: "#9a46ef"}}>impact.</span></h1> */}<h5 className=" display-one">Join Jahid Hasan’s High-Impact Training Program and Transform Your Life, Business & Income</h5>

                                    <p className="description">No two events are the same. Find the perfect training program for your life, business and income development.
                                    </p>
                                    <div>
                                    
                                    <div className="button-group">
                                        <a className="btn-default btn-medium round btn-icon" href="#trainingform">Book Now <i className="icon"><FiArrowRight /></i></a>
                                        {/* <Link className="btn-default btn-medium btn-border round btn-icon" to="#">Contact Us <i className="icon"><FiArrowRight /></i></Link> */}
                                    </div>
                                    <img style={{height: "100px", marginTop:"10px"}} src={`${process.env.PUBLIC_URL}/images/training/down-arrow.avif`} alt="Corporate Logo" />

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Slider Area  */}


                {/* Start Speaker Info*/}
                <div className="rwt-advance-tab-area rn-section-gap">
                    <div className="container">
                        <div className="row mb--40">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign = "text-center"
                                    radiusRounded = ""
                                    // subtitle = "Consulting Services"
                                    title = "Training Programs"
                                    description = ""
                                />
                            </div>
                        </div>
                        {/* <TrainingDetails/> */}
                        <TrainingTrainer/>
                    </div>
                </div>
                {/* End Speaker Info  */}

                {/* Start Speaker Menu*/}
                <div className="rwt-callto-action-area">
                    <div className="wrapper">
                        <TrainingMenu />
                    </div>
                </div>
                {/* End Speaker Menu  */}
                {/* Start Speaker About*/}
                <div className="rwt-advance-tab-area rn-section-gap" id='about'>
                    <div className="container">
                        {/* <TrainingAbout/> */}
                        <SpeakerAbout/>
                    </div>
                </div>
                {/* End Speaker About  */}

                {/* Start Elements Area  */}
                <div className="rwt-video-popup-area rn-section-gap" id='videos'>
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                        {/* <SectionTitle
                                            textAlign = "text-center"
                                            radiusRounded = ""
                                            // subtitle = "Popup Video"
                                            title = "Videos"
                                            description = ""
                                        /> */}
                                        <h4 className='text-left'>Videos</h4>
                                </div>
                            </div>
                            <TrainingVideo />
                        </div>
                    </div>
                    {/* End Elements Area  */}

                <div className="rwt-advance-tab-area rn-section-gap" id='topics'>
                    <div className="container">
                        <h4 className='text-left'>Pricing</h4>
                        <TrainingTopics/>
                    </div>
                </div>

                <div className="rwt-advance-tab-area rn-section-gap" id='trainingform'>
                    <div className="container">
                        <h4 className='text-left'></h4>
                        <TrainingForm/>
                    </div>
                </div>
                {/* End Speaker About  */}

                {/* Start Elements Area Testimonmial */}
                <div className="rwt-elements-area rn-section-gap" id='testimonial'>
                        <div className="container">
                            <div className="row mb--20">
                                <div className="col-lg-12">
                                    <SectionTitle
                                        textAlign = "text-center"
                                        radiusRounded = ""
                                        subtitle="Client Feedback"
                                    title="Our Awesome Client."
                                    description="We Provide The Best Training & Consulting Services to Improve Your Life, Business & Income."
                                    />
                                </div>
                            </div>
                            <MainTestimonial teamStyle="" />
                        </div>
                    </div>
                {/* End Elements Area  */}



                {/* Start Categories Area  */}
                <div className="rwt-brand-area rn-section-gap">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign = "text-center"
                                    radiusRounded = ""
                                    // subtitle = "Our Awesome Client"
                                    title = "Featured Category"
                                    description = ""
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12 mt--10">
                                <TrainingCategories brandStyle="brand-style-2" />
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Categories Area  */}

                {/* Start Elements Area  */}
                {/* <div className="rwt-callto-action-area rn-section-gapBottom">
                    <div className="wrapper">
                        <TrainingCallToAction/>
                    </div>
                </div> */}
                {/* End Elements Area  */}



                <FooterOne />
                <Copyright />                    

            </main>
            
        </>
    )
}
export default Training

